export class AuditModel {
    public created_At: Date;
    public created_By: string;
    public updated_By: string;
    public updated_At: Date;
    public deleted_By: string;
    public deleted_At: Date;
    public isDeleted: boolean;
}

export class Auditors extends AuditModel {
    public clientId:number;
    public entityId:number;
    public auditorId: number
    public accountingFirmId: number
    public title: string
    public fullName: string
    public phoneNumber: string
    public mobileNumber: string
    public email: string
}

export class Checklist extends AuditModel {
    public checklistId: any;
    public jobTypeId: any;
    public entityTypeId: any;
    public entityTypeName: any;
    public description: string;
    public userName: string;
    public isForQuery:string;
}

export class AdjustAmount {
    public adjustedAmountId: number
    public clientId: number
    public entityId=null
    public jobId=null
    public taskId=null
    public adjustedAmount: number
    public description: string
    public created_By: string
}

export class attachTaskList{
    TaskId:any;
    Type:number;
    Task_Text:string;
    ClientId:number;
    DocumentId:any;
}
